/*
 * NewTreatmentPlanningStep Messages
 *
 * This contains all the text for the NewTreatmentPlanningStep container.
 */

import {defineMessages} from "react-intl";

export const scope = "app.containers.NewTreatmentPlanningStep";

export default defineMessages({
  rightContentSubHeader: {
    id: `${scope}.rightContentSubHeader`,
    defaultMessage: "Select a maximum of 1 time window",
  },
  leftContentHeader: {
    id: `${scope}.leftContentHeader`,
    defaultMessage: "Appointment",
  },
  period: {
    id: `${scope}.period`,
    defaultMessage: "Period:",
  },
  selectTimeSlot: {
    id: `${scope}.selectTimeSlot`,
    defaultMessage: "Select a time slot to plan an appointment",
  },
  yourTimeSlots: {
    id: `${scope}.yourTimeSlots`,
    defaultMessage: "Your time slots",
  },
  noValidOptions: {
    id: `${scope}.noValidOptions`,
    defaultMessage:
      "If there are no valid options in the current time slots, you could schedule a new time slot or plan a separate appoint below.",
  },
  onlyPossibleToPlanInDayPart: {
    id: `${scope}.onlyPossibleToPlanInDayPart`,
    defaultMessage:
      "This type of (aftercare/control) appointment can only be scheduled in a booked part of the day. Please contact our customer service if you wish to deviate from this.",
  },
  noOpenTimeWindows: {
    id: `${scope}.noOpenTimeWindows`,
    defaultMessage: "There are no open time windows for this date",
  },
  kptOverrideTitle: {
    id: `${scope}.kptOverrideTitle`,
    defaultMessage: "KPT Override",
  },
  kptOverrideEmpty: {
    id: `${scope}.kptOverrideEmpty`,
    defaultMessage: "None",
  },
});
